import React from 'react'
import LeftArea from './LeftArea'
import Onay from './Onay'

const Kayit2 = () => {
  const email = true
  return (
    <div className="containerMain grid items-start grid-cols-1 xl:grid-cols-2 gap-20 xl:gap-2 justify-between mx-auto place-items-center h-auto my-28">
      <LeftArea email={email} />
      
      <div className="rightArea ">
        <Onay/>
      </div>
    </div>
  )
}

export default Kayit2
